import Alert from 'components/UI/Alert'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Button from 'components/UI/Buttons/Button'
import DayPicker from 'components/UI/DayPicker'
import Typography from 'components/UI/Typography'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

type SetPayDayProps = {
  payDay?: number | null
  repaymentDay?: number | null
  isLoading?: boolean
  onRepaymentDayChange: (value: number) => void
  onSetPayDay: () => void
  disabledPickerDays: (day: number) => boolean
}

const SetPayDay = ({
  payDay,
  repaymentDay,
  isLoading,
  onRepaymentDayChange,
  onSetPayDay,
  disabledPickerDays
}: SetPayDayProps) => {
  const { t } = useTranslation()
  return (
    <InfoBlock twStyle={tw`space-y-4 flex flex-col`}>
      {!payDay ? (
        <Fragment>
          <Typography variant='subbody' weight='bold'>
            {t('flow-day-choose')}
          </Typography>
          <Alert>
            <Typography variant='subbody'>{t('flow-day-choose2')}</Typography>
          </Alert>
          <DayPicker
            value={repaymentDay}
            onChange={value => onRepaymentDayChange(value)}
            disabledDays={disabledPickerDays}
          />
          <Button
            variant='secondary'
            size='small'
            twStyle={tw`self-end`}
            loading={isLoading}
            disabled={!repaymentDay}
            onClick={onSetPayDay}
          >
            <Typography variant='caption' weight='bold'>
              {t('flow-choose')}
            </Typography>
          </Button>
        </Fragment>
      ) : (
        <Fragment>
          <Typography variant='subbody' weight='bold'>
            {t('flow-schedule-day')}
          </Typography>
          <DayPicker
            value={payDay}
            onChange={value => onRepaymentDayChange(value)}
            isDisabled
            disabledDays={disabledPickerDays}
          />
        </Fragment>
      )}
    </InfoBlock>
  )
}

export default SetPayDay
